"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const lodash_uniqueid_1 = __importDefault(require("lodash.uniqueid"));
const stage_style_1 = __importDefault(require("./stage.style"));
const icons_1 = require("../../icons");
class Stage extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.id = lodash_uniqueid_1.default('stage_');
        this.headerId = `${this.id}_header`;
        this.render = () => {
            const { classes, header, traceCount, expanded, onClick, children, icon } = this.props;
            return (jsx_runtime_1.jsxs("div", Object.assign({ className: classes.root, "data-cy": "atomic-stage" }, { children: [jsx_runtime_1.jsxs("button", Object.assign({ className: classes.header, disabled: !traceCount, type: "button", onClick: onClick, "aria-expanded": expanded, "aria-controls": this.id }, { children: [jsx_runtime_1.jsx("div", Object.assign({ className: classes.icon }, { children: icon }), void 0),
                            jsx_runtime_1.jsx("div", Object.assign({ className: classes.name, role: "heading", id: this.headerId }, { children: jsx_runtime_1.jsx("div", Object.assign({ className: classes.truncate }, { children: header }), void 0) }), void 0),
                            jsx_runtime_1.jsx("div", Object.assign({ className: classes.traceCount }, { children: traceCount }), void 0),
                            jsx_runtime_1.jsx("div", Object.assign({ className: classes.toggleIcon }, { children: expanded ? jsx_runtime_1.jsx(icons_1.icons.ArrowDownFill, {}, void 0) : jsx_runtime_1.jsx(icons_1.icons.ArrowDown, {}, void 0) }), void 0)] }), void 0),
                    jsx_runtime_1.jsx("div", Object.assign({ className: classes.items, hidden: !expanded, id: this.id, "aria-labelledby": this.headerId }, { children: expanded && children }), void 0)] }), void 0));
        };
    }
}
exports.Stage = Stage;
Stage.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    header: prop_types_1.default.string.isRequired,
    traceCount: prop_types_1.default.number.isRequired,
    onClick: prop_types_1.default.func.isRequired,
    icon: prop_types_1.default.object,
    expanded: prop_types_1.default.bool,
    children: prop_types_1.default.node
};
Stage.defaultProps = {
    expanded: false,
    children: null,
    icon: null
};
exports.default = react_jss_1.default(stage_style_1.default)(Stage);
//# sourceMappingURL=stage.js.map